import { Controller } from '@hotwired/stimulus'

// Remembers the selected value in a cookie and restores it on page load.
// Usage: <select data-controller="remember-select" data-remember-select-key-value="my_cookie_key">
export default class extends Controller {
  static values = {
    key: String
  }

  connect() {
    this.restoreSelection()
  }

  remember() {
    const value = this.element.value
    if (value) {
      document.cookie = `${this.keyValue}=${encodeURIComponent(value)}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`
    }
  }

  restoreSelection() {
    const savedValue = this.getCookie(this.keyValue)
    if (savedValue && this.hasOption(savedValue)) {
      this.element.value = savedValue
    }
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
    return match ? decodeURIComponent(match[2]) : null
  }

  hasOption(value) {
    return Array.from(this.element.options).some(option => option.value === value)
  }
}
